import { render, staticRenderFns } from "./ProcessBaseInfo.vue?vue&type=template&id=6e225f90&scoped=true"
import script from "./ProcessBaseInfo.vue?vue&type=script&lang=js"
export * from "./ProcessBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./ProcessBaseInfo.vue?vue&type=style&index=0&id=6e225f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e225f90",
  null
  
)

export default component.exports